var map = {
	"./ads.jpg": 35,
	"./ads2.jpg": 36,
	"./mobile.jpg": 37,
	"./mobile2.jpg": 38,
	"./mobile3.jpg": 39,
	"./one.jpg": 16,
	"./three.jpg": 18,
	"./two.jpg": 17
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;